<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2022-04-07 14:45:47
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Leave\LeaveBalance\LeaveBalance.vue
 -->
<template>
  <ContentLayout
    :title="$t('label_essweb_admin_leaveBalance_list_title')"
    pad="0"
    filterable
    @filter="
      (val) => {
        filterPageData = val;
      }
    "
    :exportBtn="
      selectOneStaff &&
      hasBtn('export-admin-leave-transaction') &&
      curTab == 'tab-2'
    "
    :importBtn="
      hasBtn('import-admin-leave-transaction') && Number(clientMode) !== 2
    "
    :import-options="{
      api: '/leave-transaction-record/import/',
      templateUrl:
        'https://assets.essencehr.io/web/ess-business/assets/leave-transaction-record-import-template.xlsx',
      success: (result) => {
        selectOneStaff = null;
      },
    }"
    @export="onExport"
  >
    <template v-slot:top-selection="{ filter }">
      <Selections2
        :objects="filterObjects"
        small-chip
        @filter="
          filter();
          toFilter(filter);
        "
        @update="
          (prop, value, selected) => {
            if (prop == 'department') curDept = value; //触发岗位更新下拉
            $fliterValue(filterObjects, prop, value, selected);
          }
        "
        @reset="
          (apply) => {
            $fliterValue(filterObjects, null, null);
            if (apply) {
              filter();
              toFilter(filter);
            }
          }
        "
      />
    </template>
    <!-- content -->
    <template v-slot:page-main>
      <v-card class="transparent d-flex flex-row rounded-lg" elevation="0">
        <!-- left -->
        <v-card
          class="fill-height white rounded-lg pa-0"
          elevation="0"
          width="280"
          :style="{
            minHeight: $vuetify.breakpoint.height - 238 + 42 - 48 + 'px',
          }"
        >
          <noContent v-if="show_Staff.length == 0 && !staff_Loading" />
          <v-sheet
            v-if="staff_Loading"
            :style="{
              minHeight: $vuetify.breakpoint.height - 238 + 42 - 48 + 'px',
            }"
            class="text-center d-flex align-center justify-center"
          >
            <v-progress-circular
              indeterminate
              color="primary"
              size="30"
              width="2"
            ></v-progress-circular>
          </v-sheet>
          <v-list
            dense
            v-if="!staff_Loading"
            :style="{
              maxHeight: $vuetify.breakpoint.height - 238 + 42 - 48 + 'px',
            }"
            class="scroll_content_y"
          >
            <v-list-item-group v-model="selectOneStaff" color="primary">
              <v-list-item
                v-for="(staff, index) in show_Staff"
                :key="`staff---${index}`"
                dense
                two-line
                :value="staff.staff_id"
                class="pa-0 px-2 ma-0"
              >
                <v-list-item-avatar size="36" class="pa-0 ma-0 mr-2">
                  <StaffAvatar
                    size="36"
                    :src="staff.staff_avatar"
                    :staff_name="staff.preferred_name"
                  />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="text-body-2">
                    {{ $getCommonLangValue(staff.preferred_name) }}
                    <span class="text--secondary text-caption-xs">{{
                      staff.staff_code
                    }}</span>
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-body-2">
                    {{ $getCommonLangValue(staff.job_post_name) }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
        <!-- left -->
        <v-card
          class="ml-3 rounded-lg flex-grow-1"
          elevation="0"
          :style="{
            maxWidth: 'calc(100% - 292px)',
          }"
        >
          <Taber
            special
            backgroundColor="white"
            :curTab="curTab"
            @change="(tab) => (curTab = tab)"
            :items="taber"
          >
            <template v-slot:content-1>
              <Tabler
                :headers="BalanceHeaders"
                :items="BalanceDeserts"
                type="leavebalance"
                content-class="px-4 py-0"
                :height="$vuetify.breakpoint.height - 335 - 48 + 16"
                :totalCount="totalCount1"
                @change="
                  (page, perpage, callback) => {
                    getDetail(selectOneStaff, page, perpage, callback);
                  }
                "
              >
                <template v-slot:item.leave_type_name="{ item }">
                  <div class="text--primary table-title">
                    {{ $getCommonLangValue(item.leave_type_name) }}
                  </div>
                </template>
                <template v-slot:item.unit="{ item }">
                  <div class="text--primary table-title">
                    {{
                      item.unit == "D"
                        ? $t("label_essweb_system_dayLabel")
                        : item.unit == "H"
                        ? $t("label_essweb_system_hourLabel")
                        : $t("label_essweb_system_minutesLabel")
                    }}
                  </div>
                </template>
                <template v-slot:item.leave_brought_forward="{ item }">
                  <div class="text--primary table-title">
                    {{
                      item.leave_brought_forward
                        | CalculationByDHFilter(item, CalculationByDH)
                    }}
                  </div>
                </template>
                <template v-slot:item.leave_entitlement="{ item }">
                  <div class="text--primary table-title">
                    {{
                      item.leave_entitlement
                        | CalculationByDHFilter(item, CalculationByDH)
                    }}
                  </div>
                </template>
                <template v-slot:item.leave_earned="{ item }">
                  <div class="text--primary table-title">
                    {{
                      item.leave_earned
                        | CalculationByDHFilter(item, CalculationByDH)
                    }}
                  </div>
                </template>
                <template v-slot:item.leave_taken="{ item }">
                  <div class="text--primary table-title">
                    {{
                      item.leave_taken
                        | CalculationByDHFilter(item, CalculationByDH)
                    }}
                  </div>
                </template>
                <template v-slot:item.leave_balance="{ item }">
                  <div class="text--primary table-title">
                    {{
                      item.leave_balance
                        | CalculationByDHFilter(item, CalculationByDH)
                    }}
                  </div>
                </template>
                <template v-slot:item.leave_pending="{ item }">
                  <div class="text--primary table-title">
                    {{
                      item.leave_pending
                        | CalculationByDHFilter(item, CalculationByDH)
                    }}
                  </div>
                </template>
                <template v-slot:item.leave_future_balance="{ item }">
                  <div class="text--primary table-title">
                    {{
                      item.leave_future_balance
                        | CalculationByDHFilter(item, CalculationByDH)
                    }}
                  </div>
                </template>
                <template v-slot:item.leave_adjustment="{ item }">
                  <div class="text--primary table-title">
                    {{
                      item.leave_adjustment
                        | CalculationByDHFilter(item, CalculationByDH)
                    }}
                  </div>
                </template>
                <template v-slot:item.leave_forfieted="{ item }">
                  <div class="text--primary table-title">
                    {{
                      item.leave_forfieted
                        | CalculationByDHFilter(item, CalculationByDH)
                    }}
                  </div>
                </template>
                <template v-slot:item.leave_encashed="{ item }">
                  <div class="text--primary table-title">
                    {{
                      item.leave_encashed
                        | CalculationByDHFilter(item, CalculationByDH)
                    }}
                  </div>
                </template>
                <template v-slot:item.leave_accrued="{ item }">
                  <div class="text--primary table-title">
                    {{
                      item.leave_accrued
                        | CalculationByDHFilter(item, CalculationByDH)
                    }}
                  </div>
                </template>
                <template v-slot:item.action="{ item }">
                  <v-btn
                    icon
                    v-if="hasBtn('view-admin-leave-balance') && clientMode == 2"
                    @click="toView(item)"
                  >
                    <svg-icon
                      size="24"
                      fill="currentColor"
                      iconClass="viewDetail"
                    />
                  </v-btn>
                </template>
              </Tabler>
            </template>
            <template v-slot:content-2>
              <v-sheet
                v-if="clientMode != 2 && selectOneStaff"
                class="d-flex justify-end px-4 mb-n4"
              >
                <v-btn
                  text
                  class="text-capitalize"
                  v-if="hasBtn('add-admin-leave-transaction')"
                  color="primary"
                  @click="showNewTran = true"
                >
                  {{
                    $t(
                      "label_essweb_leaveBalance_form_dialog_addLeaveTransactionBtnLabel"
                    )
                  }}
                  <span class="material-icons-round">add</span>
                </v-btn>
              </v-sheet>
              <Tabler
                :headers="TransactionHeaders"
                :height="
                  $vuetify.breakpoint.height -
                  335 -
                  48 -
                  (clientMode != 2 ? 0 : 24)
                "
                :items="TransactionDeserts"
                type="leavebalance"
                :totalCount="totalCount2"
                @change="
                  (page, perpage, callback) => {
                    getTransaction(selectOneStaff, page, perpage, callback);
                  }
                "
              >
                <template v-slot:item.swift_id="{ item }">
                  <div class="text--primary table-title">
                    {{ item.swift_number }}
                  </div>
                </template>
                <template v-slot:item.tr_type="{ item }">
                  <div class="text--primary table-title">
                    {{ $getCommonLangValue(item.leave_transaction_type_name) }}
                  </div>
                </template>
                <template v-slot:item.leave_type="{ item }">
                  <div class="text--primary table-title">
                    {{ $getCommonLangValue(item.leave_type_name) }}
                  </div>
                </template>
                <template v-slot:item.start_date="{ item }">
                  <div class="text--primary table-title">
                    {{ $getDateTime(item.start_utc_datetime, "YYYY/MM/DD") }}
                  </div>
                  <div class="text--secondary table-subtitle">
                    {{ $getDateTime(item.start_utc_datetime, "HH:mm") }}
                  </div>
                </template>
                <template v-slot:item.effect_date="{ item }">
                  <div class="text--primary table-title">
                    {{
                      $getDateTime(item.effective_utc_datetime, "YYYY/MM/DD")
                    }}
                  </div>
                </template>
                <template v-slot:item.expiry_date="{ item }">
                  <div class="text--primary table-title">
                    {{ $getDateTime(item.expired_utc_datetime, "YYYY/MM/DD") }}
                  </div>
                </template>
                <template v-slot:item.unit="{ item }">
                  <div class="text--primary table-title">
                    {{
                      item.unit == "D"
                        ? $t("label_essweb_system_dayLabel")
                        : item.unit == "H"
                        ? $t("label_essweb_system_hourLabel")
                        : $t("label_essweb_system_minutesLabel")
                    }}
                  </div>
                </template>
                <template v-slot:item.total="{ item }">
                  <div
                    class="table-title"
                    :class="
                      Number(item.total_minutes) > 0
                        ? 'green--text'
                        : Number(item.total_minutes) < 0
                        ? 'red--text'
                        : 'text--primary'
                    "
                  >
                    {{
                      Number(item.total_minutes) > 0
                        ? "+"
                        : Number(item.total_minutes) < 0
                        ? ""
                        : ""
                    }}
                    {{
                      item.total_minutes
                        | CalculationByDHFilter(item, CalculationByDH)
                    }}
                  </div>
                </template>
                <template v-slot:item.status="{ item }">
                  <StatusChip
                    :slideColor="
                      item.status_value == '1'
                        ? 'orange'
                        : item.status_value == '2' ||
                          item.status_value == '3' ||
                          item.status_value == '4'
                        ? 'grey'
                        : item.status_value == '0' ||
                          item.status_value == '5' ||
                          item.status_value == '6'
                        ? 'green'
                        : 'currentColor'
                    "
                  >
                    <template v-slot:status>
                      {{ $getCommonLangValue(item.status_name) }}
                    </template>
                  </StatusChip>
                </template>
                <template v-slot:item.action="{ item }">
                  <v-btn
                    small
                    icon
                    v-if="hasBtn('view-admin-leave-transaction')"
                    @click="
                      detailUuid = item.uuid;
                      showViewTran = true;
                    "
                  >
                    <svg-icon
                      size="24"
                      fill="currentColor"
                      iconClass="viewDetail"
                    />
                  </v-btn>
                </template>
              </Tabler>
            </template>
          </Taber>
        </v-card>
      </v-card>
    </template>
    <template v-slot:tools-main>
      <normalDialog
        :dialog="showDelete"
        deleteModel
        :title="$t('label_essweb_admin_leaveBalance_list_title')"
        @close="showDelete = false"
        @confirm="toDelete"
      />
      <newTransactions
        :show="showNewTran"
        :staff_uuid="selectOneStaff"
        @close="showNewTran = false"
        :curUuid="selectOneStaff"
        @onNew="onNewTransaction"
      />
      <viewTransactions
        :show="showViewTran"
        :staff_uuid="selectOneStaff"
        @close="
          showViewTran = false;
          detailUuid = null;
        "
        :curUuid="selectOneStaff"
        :detailUuid="detailUuid"
      />
      <viewLeaveBalance ref="detailAdminBalance" :headers="BalanceHeaders" />
    </template>
  </ContentLayout>
</template>
<script>
import newTransactions from "@/Page/EssAdmin/Leave/LeaveBalance/components/newTransactions";
import viewTransactions from "@/Page/EssAdmin/Leave/LeaveBalance/components/viewTransactions";
import viewLeaveBalance from "@/Page/EssAdmin/Leave/LeaveBalance/components/viewLeaveBalance";
import { mapGetters } from "vuex";
export default {
  name: "curLeaveBalance",
  components: { newTransactions, viewTransactions, viewLeaveBalance },
  computed: {
    ...mapGetters(["clientMode"]),
  },
  data() {
    return {
      standard_working_minutes: 1,
      staff_Loading: false,
      iSEdited: false,
      allStaff: [],
      show_Staff: [],
      selectOneStaff: null,
      selectWillStaff: null,
      isFocus: false,
      totalCount1: 0,
      totalCount2: 0,
      curTab: "tab-1",
      taber: [
        "label_essweb_leaveBalance_form_tab_BalanceLabel",
        "label_essweb_leaveBalance_form_tab_Transaction",
      ],
      showDelete: false,
      detailUuid: null,
      showNewTran: false,
      showViewTran: false,
      BalanceHeaders: [
        {
          text: "label_essweb_leaveBalance_form_leaveTypeLabel",
          value: "leave_type_name",
          tran: true,
          align: "start",
          sortable: false,
        },

        {
          text: "label_essweb_leaveBalance_form_broughtForwardLabel",
          value: "leave_brought_forward",
          unit: true,
          // permission: "is_show_brought_over",
          align: "center",
          width: 80,
          sortable: false,
        },
        {
          text: "label_essweb_leaveBalance_form_entitledLabel",
          value: "leave_entitlement",
          unit: true,
          // permission: "is_show_entitlement",
          align: "center",
          width: 80,
          sortable: false,
        },
        {
          text: "label_essweb_leaveBalance_form_earnedLabel",
          value: "leave_earned",
          align: "center",
          width: 80,
          // permission: "is_show_earned",
          unit: true,
          sortable: false,
        },
        {
          text: "label_essweb_leaveBalance_form_takeExpiredLabel",
          value: "leave_taken",
          align: "center",
          unit: true,
          // permission: "is_show_taken",
          sortable: false,
        },
        {
          text: "label_essweb_leaveBalance_form_balanceLabel",
          value: "leave_balance",
          align: "center",
          unit: true,
          // permission: "is_show_balance",
          width: 80,
          sortable: false,
        },
        {
          text: "label_essweb_leaveBalance_form_pendingLabel",
          value: "leave_pending",
          // permission: "is_show_pending",
          unit: true,
          align: "center",
          width: 80,
          sortable: false,
        },
        {
          text: "label_essweb_leaveBalance_form_futureBalanceLabel",
          value: "leave_future_balance",
          align: "center",
          unit: true,
          width: 80,
          sortable: false,
        },
        {
          text: "label_essweb_leaveBalance_form_unitLabel",
          value: "unit",
          align: "center",
          width: 60,
          sortable: false,
        },
        // 2022-03-24 新增字段 BJ
        {
          text: "label_essweb_leaveBalance_form_adjustmentLabel",
          value: "leave_adjustment",
          unit: true,
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_leaveBalance_form_forfietedLabel",
          value: "leave_forfieted",
          unit: true,
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_leaveBalance_form_encashedLabel",
          value: "leave_encashed",
          unit: true,
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_leaveBalance_form_accruedLabel",
          value: "leave_accrued",
          unit: true,
          align: "start",
          sortable: false,
        },
        // 2022-03-24 新增字段 BJ
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      BalanceDeserts: [],
      TransactionHeaders: [
        {
          text: "label_essweb_leaveBalance_form_swiftIdLabel",
          value: "swift_id",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_leaveBalance_form_transactionTypeLabel",
          value: "tr_type",
          align: "center",
          sortable: false,
        },
        {
          text: "label_essweb_leaveBalance_form_leaveTypeLabel",
          value: "leave_type",
          align: "center",
          sortable: false,
        },
        {
          text: "label_essweb_leaveBalance_form_startDateLabel",
          value: "start_date",
          align: "start",
          sortable: true,
          sort: (prop, desc, calback) => {
            return this.$sortList(
              this.TransactionDeserts,
              "start_utc_datetime",
              desc ? true : false,
              "datetime"
            ).then((res) => {
              calback(desc);
              this.TransactionDeserts = res;
            });
          },
        },
        {
          text: "label_essweb_leaveBalance_form_effectiveDataLabel",
          value: "effect_date",
          align: "start",
          sortable: true,
          sort: (prop, desc, calback) => {
            return this.$sortList(
              this.TransactionDeserts,
              "effective_utc_datetime",
              desc ? true : false,
              "datetime"
            ).then((res) => {
              calback(desc);
              this.TransactionDeserts = res;
            });
          },
        },
        {
          text: "label_essweb_leaveBalance_form_expiredDateLabel",
          value: "expiry_date",
          align: "start",
          sortable: true,
          sort: (prop, desc, calback) => {
            return this.$sortList(
              this.TransactionDeserts,
              "expired_utc_datetime",
              desc ? true : false,
              "datetime"
            ).then((res) => {
              calback(desc);
              this.TransactionDeserts = res;
            });
          },
        },

        {
          text: "label_essweb_leaveBalance_form_totalLabel",
          value: "total",
          width: 80,
          align: "center",
          sortable: false,
        },
        {
          text: "label_essweb_leaveBalance_form_unitLabel",
          value: "unit",
          width: 60,
          align: "center",
          sortable: false,
        },
        {
          text: "label_essweb_leaveBalance_form_status",
          value: "status",
          align: "start",
          sortable: false,
        },

        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      TransactionDeserts: [],
      filterPageData: null,
      curDept: [],
      filterObjects: [
        {
          type: "select",
          sequence: 0,
          position: "right",
          showKey: "preferred_name",
          subKey: "job_post_name",
          name: "staff",
          multiple: true,
          avatar: true,
          twoLine: true,
          label: "label_essweb_attendanceRecord_list_staffLabel",
          value: [],

          selected: [],
          data: {
            api: "all_staff",
            url_type: "all_staff",
            args: null,
            table: "mrbase_sys_staffs",
            type: "",
            modelKey: "staff_code",
            valueKey: "staff_id",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 1,
          position: "right",
          showKey: "org_level_name",
          name: "department",
          multiple: true,
          label: "label_essweb_UM_filters_departmentLabel",
          value: [],
          selected: [],
          data: {
            api: "/dept/get-tree/",
            url_type: "tree",
            args: null,
            table: "mrbase_sys_org_levels",
            type: "",
            modelKey: "org_level_name",
            valueKey: "uuid",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 2,
          position: "right",
          showKey: "job_post_name",
          name: "job",
          disabled: false,
          multiple: true,
          label: "label_essweb_UM_filters_jobLabel",
          value: [],
          selected: [],
          data: {
            api: "/job-post/get-list/",
            url_type: "primary",
            args: { dept_uuid: "" },
            table: "mrbase_sys_job_posts",
            type: "",
            modelKey: "job_post_name",
            valueKey: "uuid",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 3,
          position: "right",
          showKey: "dict_label",
          name: "staff_status",
          disabled: false,
          multiple: true,
          label: "label_essweb_UM_filters_jobStatusLabel",
          value: [],
          selected: [],
          data: {
            api: "/dictionary/list-dictionary-byname/",
            url_type: "primary",
            args: { dict_name: "staffStatus" },
            table: "mrbase_sys_dict",
            type: "lang",
            modelKey: "dict_label",
            valueKey: "dict_value",
            global: false,
          },
        },
      ],
    };
  },
  watch: {
    selectOneStaff(val) {
      const that = this;
      this.curTab = "tab-1";
      that.BalanceDeserts = [];
      that.TransactionDeserts = [];
      this.$Sleep(600).then(() => {
        if (val) {
          that.getDetail(val, 1, this.$tableSetting.perPageSize, () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          });
        } else {
          // that.BalanceDeserts = [];
          // that.TransactionDeserts = [];
        }
      });
    },
    curDept(val) {
      //监听部门变化
      this.$fliterValue(this.filterObjects, "job", []);
      if (!val || val.length == 0) {
        this.filterObjects[2]["disabled"] = true;
      }
      if (val) {
        let arr = [];
        if (val.length) {
          this.filterObjects[2]["disabled"] = false;
          val.map((e) => {
            if (e && e.uuid) arr.push(e.uuid);
          });
          this.filterObjects[2]["data"]["args"]["dept_uuid"] = arr.join(",");
        } else {
          return;
        }
      }
    },
  },
  mounted() {
    this.getBtnPermissionList();
    this.getStaff();
  },
  filters: {
    CalculationByDHFilter: function (minutes, obj, callback) {
      return callback(minutes, obj["unit"]);
    },
  },
  methods: {
    getStaff(data) {
      this.staff_Loading = true;
      this.$getStaffList(Object.assign({}, data ? data : {})).then((res) => {
        this.allStaff = res;
        this.show_Staff = res;
        this.staff_Loading = false;
      });
    },
    toFilter(callback) {
      const that = this;
      this.desserts = [];
      this.selectOneStaff = null;
      let object = [];
      object = this.filterObjects.filter((ele) =>
        Object.prototype.toString.call(ele["value"]).toLowerCase() ===
        "[object array]"
          ? ele["value"].length
          : ele.value !== undefined && ele.value != ""
      );
      let data = {};
      object.map((item) => {
        if (item["name"] == "staff")
          data["staff_uuid"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "staff_status")
          data["staff_status"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "job")
          data["job_post_uuid"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "department") {
          let arr = [];
          if (item.value.length) {
            item.value.map((e) => {
              e && e.uuid ? arr.push(e.uuid) : null;
            });
          }
          data["dept_uuid"] = arr.join(",");
        }
      });
      this.getStaff(data);
    },
    onExport() {
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_transaction_record",
        url: "/leave-transaction-record/export/",
        data: {
          staff_uuid: this.selectOneStaff,
        },
        type: "export",
        export_title: this.$t("label_essweb_leaveBalance_form_tab_Transaction"),
      });
    },
    CalculationByDH: function (minutes, unit) {
      let stand = this.standard_working_minutes;
      if (
        minutes === undefined ||
        minutes === null ||
        minutes === "" ||
        unit === null ||
        unit === ""
      ) {
        return minutes;
        // +  this.$t("label_essweb_system_minutesLabel");
      }
      if (unit === "D") {
        if (stand === "" || stand === null) {
          return minutes;
          // +  this.$t("label_essweb_system_minutesLabel");
        }
        return parseFloat((Number(minutes) / Number(stand)).toFixed(4));
        // +
        // this.$t("label_essweb_system_dayLabel")
      } else if (unit === "H") {
        return parseFloat((Number(minutes) / 60).toFixed(4));
        // +
        // this.$t("label_essweb_system_hourLabel")
      } else {
        return minutes;
        // +  this.$t("label_essweb_system_minutesLabel");
      }
    },

    toDelete: function (uuid) {},
    getDetail: function (staff, page, perpage, callback) {
      const that = this;
      this.BalanceDeserts = [];
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_balance",
        url: "/leave-balance/get-list/",
        data: {
          staff_uuid: staff,
          cpage: page,
          pagesize: perpage,
        },
      }).then((res) => {
        that.standard_working_minutes = res.data["standard_working_minutes"];
        that.BalanceDeserts = res.data["ess_lv_leave_balance"];
        that.totalCount1 = res.totalcount;
        that.getTransaction(staff, 1, that.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
        callback ? callback(page, perpage, null) : null;
      });
    },
    onNewTransaction: function (obj) {
      const that = this;
      this.showNewTran = false;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_transaction_record",
        url: "/leave-transaction-record/add/",
        data: obj,
      }).then((res) => {
        that.getDetail(
          that.selectOneStaff,
          1,
          that.$tableSetting.perPageSize,
          () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          }
        );
        that.getTransaction(
          that.selectOneStaff,
          1,
          that.$tableSetting.perPageSize,
          () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          }
        );
      });
    },
    getTransaction: function (staff, page, perpage, callback) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_transaction_record",
        url: "/leave-transaction-record/get-list/",
        data: {
          staff_uuid: staff,
          cpage: page,
          pagesize: perpage,
        },
      }).then((res) => {
        that.TransactionDeserts = res.data;
        that.totalCount2 = res.totalcount;
        callback ? callback(page, perpage, null) : null;
      });
    },
    toView: function (obj) {
      this.$refs.detailAdminBalance.view(
        this.selectOneStaff,
        obj.leave_type_uuid,
        2,
        obj
      );
    },
  },
};
</script>
